import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";

import type {
  GeneralReservoirManagementFilters,
  ListGeneralReservoirManagementsResponse,
} from "./generalReservoirManagement.types";

const GENERAL_RESERVOIR_MANAGEMENT_QUERY_KEY = "general-reservoir-management";

export const getGeneralStructureReservoirManagement = async (
  structureId: string,
  params?: GeneralReservoirManagementFilters,
): Promise<ListGeneralReservoirManagementsResponse> => {
  const cleanParams = Object.fromEntries(
    Object.entries(params ?? {}).filter(
      ([, value]) => value !== undefined && value !== "",
    ),
  );

  return axiosGetData<ListGeneralReservoirManagementsResponse>(
    `v1/general/structures/${structureId}/reservoir-management`,
    cleanParams,
  );
};

export const generalStructureReservoirManagementQueryOptions = (
  structureId: string,
  params?: GeneralReservoirManagementFilters,
) => ({
  queryKey: [GENERAL_RESERVOIR_MANAGEMENT_QUERY_KEY, structureId, params ?? {}],
  queryFn: () => getGeneralStructureReservoirManagement(structureId, params),
});

export const useGeneralStructureReservoirManagementQuery = (
  structureId: string | undefined,
  params?: GeneralReservoirManagementFilters,
  options?: Partial<UseQueryOptions<ListGeneralReservoirManagementsResponse, AxiosError>>,
) =>
  useQuery<ListGeneralReservoirManagementsResponse, AxiosError>({
    ...generalStructureReservoirManagementQueryOptions(structureId ?? "", params),
    enabled: Boolean(structureId),
    ...options,
  });
